import {useState, useEffect, useContext} from 'react';

import {useDebounce} from './useDebounce';
import {EventBusContext} from '../providers/EventBus';

export const useSearchStrategy = <T>(
  strategy: ((arg: string) => Promise<T[]>) | null,
  prefetchDefault: boolean = false,
  canSearch: boolean = true,
) => {
  const [prefetch, setPrefetch] = useState(prefetchDefault);
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearch = useDebounce(searchTerm, 300);
  const [data, setData] = useState<T[]>([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const {bus} = useContext(EventBusContext);

  const sideEffect = async () => {
    if (canSearch && strategy) {
      try {
        const res = await strategy(debouncedSearch);

        setSearchLoading(false);
        setData(res as T[]);
      } catch (err: unknown) {
        bus?.emit('error', [err]);

        setSearchLoading(false);
      } finally {
        if (prefetch) {
          setPrefetch(false);
        }
      }
    }
  };

  useEffect(() => {
    // prefetch && setSearchLoading(true)
    if (canSearch && strategy && !searchLoading) {
      setSearchLoading(true);
    }

    // searchTerm === '' && !prefetch
    //     && setSearchLoading(false)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  useEffect(() => {
    sideEffect();

    return () => {
      !canSearch && setData([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearch]);

  const handleSearch = (value: string) => {
    setSearchTerm(value);
  };

  const resetSearch = () => {
    setSearchLoading(false);
    setSearchTerm('');
    setData([]);
  };

  return {handleSearch, data, searchTerm, searchLoading, resetSearch, debouncedSearch};
};
